import Game from '@/components/pages/Game.vue'
import GameResult from '@/components/pages/GameResult.vue'
import { freeContentPageComponents } from '@/components/routes/free-content-page'
import { ShopEntryApiService } from '@/services/api/shop-entry'
import { SyncSession } from '@/services/session/sync-session'
import { ShopEntryTargetResolver } from '@/services/shop-entry/target-resolver'
import Router, { Route } from 'vue-router'

/**
 * ページリストを展開したときに出てくる router-viewタグの
 * name プロパティに入る可能性があるコンポーネントを登録する。
 */
const gameResultChildren = [{
  path: '',
  components: {
    ...freeContentPageComponents,
  },
}]

const tryEntry = (to: Route, _from: Route, next) => {
  // 入店チェックはページ表示の裏で行う
  // 通常時に入店拒否されることはほぼないので、ここでawaitするほうが損が大きいと判断した
  // 厳格モード的なものを導入してイベント時にONにするなどは検討の余地あり
  SyncSession.onSynced(async () => {
    const shopEntryApiService = new ShopEntryApiService()
    const maybeShopEntryTarget = ShopEntryTargetResolver.resolveBrandEnglishName(to)
    if (maybeShopEntryTarget.isSome()) {
      shopEntryApiService.update(to.path, maybeShopEntryTarget.value)
    }
  })

  return next()
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/game/:campaign_id',
      component: Game,
      props: route => ({
        campaignId: route.params.campaign_id,
      }),
      beforeEnter: tryEntry,
    },
    {
      path: '/:brand_english_name/game/:campaign_id',
      component: Game,
      props: route => ({
        brandEnglishName: route.params.brand_english_name,
        campaignId: route.params.campaign_id,
      }),
      beforeEnter: tryEntry,
    },
    {
      path: '/game/:campaign_id/result',
      component: GameResult,
      props: route => ({
        campaignId: route.params.campaign_id,
      }),
      beforeEnter: tryEntry,
      children: gameResultChildren,
    },
    {
      path: '/:brand_english_name/game/:campaign_id/result',
      component: GameResult,
      props: route => ({
        brandEnglishName: route.params.brand_english_name,
        campaignId: route.params.campaign_id,
      }),
      beforeEnter: tryEntry,
      children: gameResultChildren,
    },
  ],
})
